<template>
    <div id="loginPage">
        <div>
            <div class="header">
                <i class="el-icon-menu"></i>
                <label>ITMA</label>
            </div>
            <el-row type="flex" justify="center" align="middle" :style="{height:(clientH-101)+'px'}">
                <div class="grid-content">
                    <el-card class="box-card">
                        <el-form label-position="right" :model="loginForm">
                              <el-form-item>
                                    <el-input 
                                        v-model="loginForm.userName"
                                        placeholder="用户名">
                                    </el-input>
                              </el-form-item>
                              <el-form-item>
                                    <el-input
                                        type="password"
                                        v-model="loginForm.password"
                                        placeholder="密码"
                                        @keyup.native.13="login">
                                    </el-input>
                              </el-form-item>
                              <el-form-item>
                                    <el-button type="success" style="width:100%" @click="login">登录</el-button>
                              </el-form-item>
                        </el-form>
                    </el-card>
                </div>
            </el-row>
            <div class="footer">
                <span>&copy;{{new Date().getFullYear()}} mingapp.cn 版权所有   </span>
                <span>
                    <a target="_blank" href="http://www.beian.miit.gov.cn" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">浙ICP备19024323号</a>
                </span>
                <span>
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32058502010481" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                        <img :src="beianImg" style="float:left;"/>
                        苏公网安备 32058502010481号
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                beianImg:require('../assets/images/beian.png'),
                clientH:document.documentElement.clientHeight,
                loginForm: {
                    userName: '',
                    password: ''
                }
            }
        },
        mounted(){
            let that = this;
            window.onresize = function(){
                that.clientH = document.documentElement.clientHeight;
            }
        },
        methods:{
            login(){
                this.$http.post('/api/login',{
                    userName:this.loginForm.userName,
                    password:this.loginForm.password
                }).then(response=>{
                    let res = response.data
                    if(res.status === 0){
                        window.sessionStorage.setItem('userName',this.loginForm.userName)
                        this.$router.push({path:'/'})
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'warning'
                        });
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .header{
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid hsla(0,0%,100%,.15);
        color: #ffffff;
        font-size:20px;
    }
    .header label{
        padding-left: 10px;
    }
    .footer{
        height: 50px;
        text-align: center;
        color: #73777a;
        background: #373d41;
        line-height: 50px;
    }
    .footer a{
        color: #73777a;
    }
    .footer a:visited{
        color: #73777a;
    }
</style>
<style>
    #loginPage{
        background-image: url('~@/assets/images/bg.jpg')
    }
    #loginPage .el-row{
        width:100%;
    }
    #loginPage .el-card{
        width:400px;
        height:228px;
        padding:45px 50px 30px 50px;
        border-radius: 0;
    }
    #loginPage .el-input__prefix{
        color:#102463;
    }
    #loginPage .logo{
        margin-bottom:5px;
        text-align:center;
        line-height:50px;
    }
    #loginPage .icon{
        font-size:50px;
    }
    #loginPage .el-input__inner,#loginPage .el-button{
        border-radius: 0;
    }
    .logo span{
        font-size:30px;
        padding-left:15px;
        font-family:'STXingkai'
    }
    #loginPage .el-button--success:focus,#loginPage .el-button--success:hover{
        border: 1px solid #00c1de;
        background: #00c1de;
    }
    #loginPage .el-button--success{
        background:#00c1de;
        border: 1px solid #00c1de;
    }
</style>